import { render } from "./alarmList.vue?vue&type=template&id=25475540"
import script from "./alarmList.vue?vue&type=script&lang=js"
export * from "./alarmList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__